var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_vm._v("Moved thief to "+_vm._s(_vm.message.area.card.kind)+" at "+_vm._s(_vm.row)+_vm._s(_vm.message.area.column)+".")])}
var staticRenderFns = []

export { render, staticRenderFns }